import * as React from 'react';
import { Component, deps, inject, observer } from '../lib/component';
import { AccountLayout } from '../components/account/layout';
import { FormattedMessage } from 'react-intl';
import { AccountOrders } from '../components/account/orders';

export interface AccountOrdersPageProps {

}

@inject(deps) @observer
export class AccountOrdersPage extends Component<AccountOrdersPageProps> {
  render() {
    const { isMobile } = this.props.model.ui;
    const { orders = [], loadingMore, pagination } = this.props.model.page.accountOrders;

    return (
      <AccountLayout>
        <FormattedMessage tagName="h2" id="account.orders.title"/>
        <AccountOrders
          orders={orders}
          loadingMore={loadingMore}
          pagination={pagination}
          pathRoot="/account/orders"
          isMobile={isMobile}
        />
      </AccountLayout>
    )
  }
}